import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import type { SessionInfo } from "../api/client";

/** Placeholder for the review workspace: timeline, video grid, audio and map
 * arrive in Phases 1-2 (project plan epics 1.8, 2.1-2.6). */
export function HomePage({ session }: { session: SessionInfo }) {
  return (
    <section>
      <Typography variant="h5" component="h2" gutterBottom>
        Review
      </Typography>
      <Typography gutterBottom>
        Signed in as <strong>{session.user.username}</strong> with roles{" "}
        {session.user.roles.length ? session.user.roles.join(", ") : "none"}.
      </Typography>
      <Paper variant="outlined" sx={{ p: 6, textAlign: "center", color: "text.secondary" }}>
        Timeline, 2×2 video grid, audio and map: Phase 1–2
      </Paper>
    </section>
  );
}
